import { ElementType } from 'react';
import cx from 'classnames';
import Button, { ButtonProps } from '../Button';
import styles from './IconButton.module.scss';

type IconButtonProps<T extends ElementType> = {
  icon: ButtonProps<T>['icon']['element'];
} & Omit<ButtonProps<T>, 'children' | 'icon'>;

function IconButton<T extends ElementType>({
  icon: Icon,
  ...props
}: IconButtonProps<T>) {
  return (
    <Button
      {...props}
      padding="0.625rem"
      variant={props.variant}
      className={cx(props.className, styles.root)}
    >
      <Icon className={styles.icon} />
    </Button>
  );
}

export default IconButton;
